const lqContent = `
<!DOCTYPE HTML>
<html lang="en">
    
    <body>


<div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
    
    <div class="html-editor parbase aem-GridColumn aem-GridColumn--default--12">



	 	<head>
    <style type="text/css">
        .mb30 {
            margin-bottom: 30px;
        }
        .ad-section {
            display: flex;
            flex-direction: row;
            flex-flow: wrap;
            background: #000000;
            align-items: center;
            height: 300px;
            font-size: 12px;

        }

        .ad-card {
            width: 30%;
            padding: 20px 25px;
            margin: 14px;
            background-color: #F6F6F6;
            height: 220px;
            border-radius: 2px;
            // margin-top: 0px;
        }

        .ad-cardbg {
            width: 30%;
            padding: 20px 25px;;
            margin: 14px;
            /* margin-top: 31px; */
            border-radius: 2px;
            background-image: url(images/bba_offer_bg-min.png);
            background-repeat: no-repeat;
            background-size: 100% 220px;
            height: 220px;
        }

        .ad-card h3,
        .ad-cardbg h3 {
            font-size: 12px;
            font-weight: bolder;
            /*font-family: "Verizon NHG eDS";*/
        }

        .ad-card .header {
            /* font-family: "Verizon NHG eDS";*/
            font-size: 20px;
            letter-spacing: 0;
            line-height: 20px;
            font-weight: bold;
            width: 100%;
            padding: 10px 2px 10px 0px;
        }
        .ad-cardbg .header {
           /* font-family: "Verizon NHG eDS";*/
            font-size: 20px;
            letter-spacing: 0;
            line-height: 20px;
            font-weight: bold;
            width: 60%;
            padding: 37px 2px 40px 0px;
        }

        /*.ad-card p,.ad-cardbg p {
    font-family: "Verizon NHG eDS";
      font-size: 12px;
      letter-spacing: 0;
      line-height: 14.4px
    }*/
        .ad-card a.cta-text,
        .ad-cardbg a.cta-text {
            width: 8px;
            height: 14px;
            /*font-family: "Verizon NHG eDS";*/
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0.5px;
            line-height: 20px;
            cursor: pointer;
            color: black;
            text-decoration: none;
        }

        .ad-descr {
            width: 30%;
            color: #FFFFFF;
            height: 91.2px;
            /*font-family: "Verizon NHG eDS";*/
            font-weight: bold;
            font-size: 32px;
            letter-spacing: 0px;
            line-height: 32px;
            padding: 0px 10px;
            margin-left: 10px;
            margin-right: 38px;
        }
        .modal-overlay {
            position: fixed;
            z-index: 999;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background-color: rgb(0,0,0,0.8);
        }

        .modal {
            position: relative;
            padding-top: 20px;
            left: 200px;
            top: 100px;
            width: 65%;
            height: auto;
            overflow: auto;
            background: white;
            color: rgb(0, 0, 0);
            margin: 0;
            padding: 20px;
            border: 1px solid #888;
            box-shadow: 0 4px 8px 0;
            text-decoration: none;

        }

        .modal-content {

            position: relative;
            max-height: 80vh;
            overflow-y: scroll;
        }

        .modal-content .head1 {
            font-size: 24px;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 24px;
        }

        .modal-content .head2 {
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0.5px;
            line-height: 20px;
        }

        .modal-content .descr {
            font-size: 16px;
            letter-spacing: 0.5px;
            line-height: 20px;
        }

        .close {
            color: #aaaaaa;
            float: right;
            font-size: 20px;
            font-weight: bold;
        }

        .close:hover,
        .close:focus {
            color: black;
            cursor: pointer;
        }

        .mb15 {
            margin-bottom: 10px;
        }

        .ad-cardbg a:after, .ad-card a:after {
            content: '';
            background-image: url(https://www.verizon.com/content/dam/verizon/business/gbcom/Arrow-black.svg);
            background-repeat: no-repeat;
            width: 8px;
            height: 14px;
            position: absolute;
            /*top: calc(50% - 26px);*/
            /* right: 17px; */
            margin-left: 10px;
            margin-top: 4px;
        }
        
        /* #offer-modal{
            width: 600px;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -40%);
            padding: 40px;
            max-height:80vh;
        }
        #offer-modal .head1 {
          font-size:32px!important;
        }
        #offer-modal .modal-content {
          max-height:60vh;
        }
        #offer-modal .close {
          color: #000;
          float: right;
          font-size: 36px;
          font-weight: bold;
          margin-top: -5px;
        } */
        .modal .head1 {
          font-size:32px!important;
          margin-top:0;
        }
        .modal .close {
          color: #000;
          float: right;
          font-size: 36px;
          font-weight: bold;
          margin-top: -10px;
        }

        @media only screen and (max-width: 48rem) {
            .ad-cardbg a:after {
                content: '';
                background-image: url(https://www.verizon.com/content/dam/verizon/business/gbcom/Arrow-black.svg);
                background-repeat: no-repeat;
                width: 8px;
                height: 14px;
                position: absolute;
                /*top: calc(50% - 154px);
             right: 17px; */
                margin-left: 6px;
            }

            .modal {
                left: 0px;
                top: 16px;
                width: 92%;
                height: 95%;
                overflow: auto;
                padding: 20px;
                margin: auto;
            }
            .modal-content {
                max-height: 90%;
            }

            .ad-section {
                display: flex;
                flex-direction: column;
                flex-flow: wrap;
                background: #000000;
                align-items: center;
                height: fit-content;

            }

            .ad-card {
                width: 95% !important;
                height: auto;
            }

            .ad-cardbg {
                width: 95%;
               /* margin-left: 0.5rem !important;*/
                background-image: url(images/bba_offer_bg_mob-min.png);
                background-repeat: no-repeat;
                background-size: 100% 100%;
                height: auto;
            }

            .ad-descr {
                width: 95%;
                height: fit-content;
                padding: 20px 0px 10px 16px;
                margin-left: 2px;
            }

            .ad-card .header,
            .ad-cardbg .header {
                   padding-top: 10px;
					font-size: 27px !important;
					line-height: 28px;
					font-weight: bold;
					width: 75%;
					padding: 20px 0px 15px 0px;
            }
            /* #offer-modal{
                width: 95%;
                padding: 20px;
                transform: translate(-50%, -62%);
            }
            #offer-modal .head1 {
                font-size:20px !important;
            }
            .modal-content .descr {							
                padding-right: 10px;
            } */
            .modal .head1 {
                font-size:20px !important;
                width: 90%;
            }
        }
          @media screen and (max-width: 1024px) and (min-width: 768px){
            .ad-descr {
                width: 42%;
                font-size: 32px;
                padding: 10px 0px 10px 16px;
            }

           .ad-cardbg {
                width: 50%;
                margin-left: 0.5rem !important;
                background-image: url(images/bba_offer_bg_mob-min.png);
                background-repeat: no-repeat;
                background-size: contain;
                /* height: 275px; */
            }
            /*.ad-section {
                height: fit-content;
            }*/
            .modal-content .descr {							
                padding-right: 10px;
            }
			 .modal {
                left: 0px;
                top: 16px;
                width: 92%;
                height: 95%;
                overflow: auto;
                padding: 20px;
                margin: auto;
            }
            .modal-content {
                max-height: 90%;
            }
            
        }

        @media only screen and (min-device-width: 1024px) and (max-device-width: 1366px){
           .ad-cardbg {
                margin-top: 35px;
            }
            
        }

        @media screen and (max-width: 1024px) and (min-width: 768px) and (orientation: landscape) {
            .ad-descr {
                      width: 37%;
						font-size: 32px;
						line-height: 32px;
						height: fit-content;
						padding: 8px 0px 10px 16px;
            }

            .ad-cardbg {
                    
                background-image: url(images/bba_offer_bg-min.png);
                background-repeat: no-repeat;
                background-size: contain;
                height: 240px;
                margin-top: 35px;
				width: 55%;
            }
			.ad-cardbg .header {
                padding-top: 10px;
                font-size:25px !important;
                line-height: 25px;
                font-weight: bold;
                width: 70%;
                padding: 16px 2px 16px 0px;
            }

           /* .ad-section {
                height: fit-content;
            }*/
            .modal-content .descr {							
                padding-right: 10px;
            }
			 .modal {
                left: 0px;
                top: 16px;
                width: 92%;
                height: 95%;
                overflow: auto;
                padding: 20px;
                margin: auto;
            }
            .modal-content {
                max-height: 90%;
            }
        }
    </style>
</head>

<body>
    <div class="ad-section">
        <div class="ad-descr">
            We offer the speed and reliability you need at a cost that will fit your organization.
        </div>
        <div class="ad-card">
            <h3>Exclusive online offer ends 11.14.22</h3>
            <div class="header">Select a Fios internet and phone bundle to get up to a $500 Visa® Prepaid card.</div>
            <div class="mb30">Exclusive online offer for new customers that bundle Fios internet and phone with a 2-yr agreement.</div>
            <a class="modal-text cta-text" data-target="offer-modal" data-toggle="modal" href="#" id="offerlink">Learn how </a>
        </div> 
        <div class="ad-cardbg">
            <!--<h3>Online joint offer</h3>	-->
            <div class="header">Verizon's business internet services come with a price guarantee</div>

            <a class="modal-text cta-text" data-target="offer-modal" data-toggle="modal" id="offerlinktwo">View details</a>
        </div>
    </div>
    <div id="offer-modal" class="modal-overlay" style="display: none;">
        <div class="modal fade" role="dialog" style="overflow: hidden">
            <span class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">&times;</span>
            <h3 class="head1 mb15">Price guarantee offer details</h3>
            <div class="modal-content">
                <div class="head2 mb15">If you qualify for Fios Business Internet or LTE Business Internet</div>
                <div class="descr mb15">
                   Available to new business customers only; subject to credit review.  Depending on plan purchased, promotional pricing is guaranteed for up to 3 years, subject to continuation of qualifying products; price guarantee applies to applicable base monthly rate only; excludes optional services and equipment charges; prices subject to increase thereafter. Terms apply.
                </div>
                <div class="head2 mb15">If you qualify for 5G Business Internet</div>
                <div class="descr mb15">
                    10-year price guarantee offer for new 5G Business Internet customers in select areas only. Guarantee applies to the internet monthly access fee, excluding applicable taxes, fees & equipment charges. Customer must also be in good standing & retain 5G Business Internet at the current service address. Any customer-initiated change to the service or service plan cancels the price guarantee (e.g., location changes & speed upgrades/downgrades). Changes or disruptions to 5G Business Internet service to your location outside of VZ’s control will cancel the price guarantee. Terms apply. Limited time offer.
                </div>
            </div>
        </div>
    </div>
    <script type="text/javascript">
        var modal = document.getElementById("offer-modal");
        var content = document.getElementById("offerlink");
        var contenttwo = document.getElementById("offerlinktwo");
        var span = document.getElementsByClassName("close")[0];
        // for moving modal code to body tag
        var docBody = document.getElementsByTagName("body")[0];
        docBody.appendChild(modal);
        //content.onclick = function () { console.log('content click test'); modal.style.display = "block"; }
        contenttwo.onclick = function () { console.log('content click test'); modal.style.display = "block"; }
        span.onclick = function () { modal.style.display = "none"; }
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    </script>
</body>



<div class="clr"></div>

</div>

    
</div>

</body>
</html>
`

export default lqContent;
